export var MODAL_STATE;
(function (MODAL_STATE) {
    MODAL_STATE["entering"] = "entering";
    MODAL_STATE["entered"] = "entered";
    MODAL_STATE["exiting"] = "exiting";
    MODAL_STATE["exited"] = "exited";
})(MODAL_STATE || (MODAL_STATE = {}));
export var MODAL_VIEW;
(function (MODAL_VIEW) {
    MODAL_VIEW["dialog"] = "dialog";
    MODAL_VIEW["page"] = "page";
    MODAL_VIEW["fullPage"] = "fullPage";
})(MODAL_VIEW || (MODAL_VIEW = {}));
//# sourceMappingURL=types.js.map